import React from 'react';
import { Shield, Zap, Target } from 'lucide-react';
export function Hero() {
  const scrollToPurchase = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="pt-12 pb-16 px-4 md:pt-20 md:pb-24 max-w-5xl mx-auto text-center" data-id="element-59">
      <h1 className="text-5xl md:text-7xl lg:text-8xl font-bebas leading-none mb-4" data-id="element-60">
        ENTRENÁ COMO LOS QUE REALMENTE PROGRESAN
      </h1>
      <h2 className="text-xl md:text-3xl font-bold text-orange-500 mb-8 uppercase tracking-wide" data-id="element-61">
        EL MÉTODO QUE USAN LOS QUE SÍ SUBEN DE NIVEL
      </h2>

      <div className="relative max-w-3xl mx-auto mb-8 cursor-pointer group" onClick={scrollToPurchase} data-id="element-62">
        <div className="absolute inset-0 bg-orange-500 opacity-0 group-hover:opacity-10 transition-opacity duration-300 rounded-xl" data-id="element-63"></div>
        <img src="https://cdn.magicpatterns.com/uploads/mGQqY8Pjy1f7dwLDGoVr5E/ChatGPT_Image_May_16,_2026,_11_39_22_PM.png" alt="Escalada Pro System Bundle" className="w-full h-auto rounded-xl shadow-2xl shadow-orange-500/20" data-id="element-64" />
      </div>

      <p className="text-gray-400 font-medium mb-6 tracking-widest uppercase text-sm md:text-base" data-id="element-65">
        6 Capítulos · 3 Bonos · Listo para usar.
      </p>

      <p className="text-lg md:text-xl text-gray-300 max-w-2xl mx-auto mb-8 leading-relaxed" data-id="element-66">
        El sistema definitivo para romper tus estancamientos y progresar de
        verdad.
      </p>

      <div className="flex flex-wrap justify-center gap-3 md:gap-6 mb-10" data-id="element-67">
        <div className="flex items-center gap-2 bg-card px-4 py-2 rounded-full border border-gray-800" data-id="element-68">
          <Zap className="w-4 h-4 text-orange-500" data-id="element-69" />
          <span className="text-sm font-medium" data-id="element-70">PDF digital</span>
        </div>
        <div className="flex items-center gap-2 bg-card px-4 py-2 rounded-full border border-gray-800" data-id="element-71">
          <Target className="w-4 h-4 text-orange-500" data-id="element-72" />
          <span className="text-sm font-medium" data-id="element-73">Acceso inmediato</span>
        </div>
        <div className="flex items-center gap-2 bg-card px-4 py-2 rounded-full border border-gray-800" data-id="element-74">
          <Shield className="w-4 h-4 text-orange-500" data-id="element-75" />
          <span className="text-sm font-medium" data-id="element-76">Todos los niveles</span>
        </div>
      </div>

      <button onClick={scrollToPurchase} className="w-full md:w-auto bg-orange-500 hover:bg-orange-600 text-white font-bold text-xl md:text-2xl py-5 px-10 rounded-xl shadow-[0_0_30px_rgba(249,115,22,0.4)] transition-all transform hover:scale-105 active:scale-95 flex items-center justify-center gap-3 mx-auto" data-id="element-77">
        <span data-id="element-78">🧗</span> QUIERO SUBIR DE GRADO AHORA
      </button>

      <div className="mt-6 flex flex-wrap justify-center items-center gap-2 text-sm text-gray-500" data-id="element-79">
        <Shield className="w-4 h-4" data-id="element-80" />
        <span data-id="element-81">Garantía 7 días</span>
        <span data-id="element-82">·</span>
        <span data-id="element-83">Pago 100% seguro</span>
        <span data-id="element-84">·</span>
        <span data-id="element-85">Mercado Pago</span>
        <span data-id="element-86">·</span>
        <span data-id="element-87">Tarjeta</span>
      </div>
    </section>;
}